import styled, { css } from 'styled-components';
import { Image } from '../../../../raw-components/image/image';

export const GameBadgeDefaultBox = styled(Image) <{ useSquareIcons?: boolean; }>`
  position: absolute;
  left: 0;
 
  ${props => props.useSquareIcons ? css`
    bottom: 0;
    max-width: 40%;
  ` 
  : css`
    top: 0;
    height: 24%;
    width: 23%;
  `}
`;
